import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { INTERCOM_APP_ID } from 'config/intercomConfig';
import { useIsAuthenticated, useRealUserInfo } from 'state';

export default function useIntercom() {
    const isAuthenticated = useIsAuthenticated();
    const { emailAddress, fullName } = useRealUserInfo();
    const { pathname } = useLocation();

    useEffect(() => {
        if (!INTERCOM_APP_ID || !window.Intercom || !isAuthenticated || !emailAddress) {
            return;
        }

        window.Intercom('boot', {
            api_base: 'https://api-iam.intercom.io',
            app_id: INTERCOM_APP_ID,
            user_id: emailAddress,
            email: emailAddress,
            name: fullName,
        });

        return () => {
            window.Intercom?.('shutdown');
        };
    }, [isAuthenticated, emailAddress, fullName]);

    useEffect(() => {
        if (!window.Intercom || !isAuthenticated || !emailAddress) {
            return;
        }

        window.Intercom('update');
    }, [pathname, isAuthenticated, emailAddress]);
}
